import { shallowEqual, useSelector } from 'react-redux';
import { getGame } from '../selectors';

export const useGame = () => ({
  game: useSelector(getGame, shallowEqual),
});
